import React from "react"

import TableComponent from "./table-component"
import Header from "./header-container"

class TableContainer extends React.Component {

	render() {
		const tableDefinition = {
			rows: this.props.ppi.revenues.map((revenue, index) => ({
				title: revenue.name,
				cellComponents: [{
					index: 0,
					component: Header
				}],
				index: index,
				readOnly: this.props.consulted,
				cellProps: {
					type: "numeric",
					format: '0,0',
					culture: 'fr-FR',
					mantissa: 0
				}
			}))
		}

		return (
			<TableComponent
				consulted={this.props.consulted}
				tableDefinition={tableDefinition}
				data={this._getData(tableDefinition)}
				ppi={this.props.ppi}
				onChange={this.props.onChange}
				onCustomAction={this.props.onCustomAction}
				previousYear={this.props.previousYear}
				currentUserType = {this.props.currentUserType}
			/>
		)
	}

	_getData(tableDefinition) {
		const ppi = this.props.ppi
		var data = new Array(tableDefinition.rows.length)
		var value
		ppi.revenues.map((revenue, index) => {
			data[index] = new Array(ppi.years.filter(y => (y.year >= this.props.current_year)).length)
			revenue.years.filter(y => (y.year >= this.props.current_year)).map((year, yindex) => {
				data[index][yindex] = Math.round(year.value)
			})
			data[index].unshift(revenue.name)

		})
		return data
	}

}

export default TableContainer



// WEBPACK FOOTER //
// ./src/component/ppi/ppi-detail/revenues/table-container.js